import { useState, useEffect, useCallback } from 'react';

export type ScreenSize = {
  width: number;
  height: number;
};

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  const handleResize = useCallback(() => {
    if (typeof window !== 'undefined') {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== screenSize.width || newHeight !== screenSize.height) {
        setScreenSize({
          width: newWidth,
          height: newHeight,
        });
      }
    }
  }, [screenSize.width, screenSize.height]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [handleResize]);

  return screenSize;
};
